document.addEventListener('DOMContentLoaded', function() {
  const mainImage = document.querySelector('.custom-media-block__main-image img');
  const thumbnails = document.querySelectorAll('.thumb-item');

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      
      const clickedImg = thumb.querySelector('img');
      mainImage.src = clickedImg.src;
    });
  });
});